import styled from 'styled-components';

const TeamStyles = styled.section`
  .header {
    margin: 2rem 0 4rem;

    .heading {
      margin: 0 0 1rem;
    }

    .controls {
      .btn {
        margin: 0 0 1.2rem;
      }
    }
  }

  .team-members {
    display: grid;
    grid-template-columns: repeat(2, 1fr);
    gap: 1.5rem;
  }

  @media (min-width: 768px) {
    .header {
      margin: 1rem 0 4rem;
      display: flex;
      justify-content: space-between;
      align-items: center;

      .heading {
        margin: 0;
      }

      .controls {
        display: flex;
        align-items: center;
        justify-content: flex-end;
        width: 60%;

        .btn {
          margin: 0 2rem 0;
        }

        .team-filter-wrap {
          max-width: 19rem;

          .react-select__control {
            height: 2.8rem;
          }
        }
      }
    }

    .team-members {
      grid-template-columns: repeat(3, 1fr);
    }
  }

  @media (min-width: 992px) {
    .header {
      margin: 3rem 0 4rem;
    }

    .team-members {
      grid-template-columns: repeat(4, 1fr);
    }
  }

  @media (min-width: 1400px) {
    .team-members {
      grid-template-columns: repeat(5, 1fr);
    }
  }
`;

export default TeamStyles;
